"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var ArrowRightIcon = function (props) {
    return ((0, jsx_runtime_1.jsxs)(material_1.SvgIcon, __assign({ fontSize: "small" }, props, { fill: "none", viewBox: "0 0 20 19", style: __assign({ color: 'transparent' }, props.style) }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M11.25 4.375L16.875 10L11.25 15.625", stroke: "current", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }), (0, jsx_runtime_1.jsx)("path", { d: "M3.125 10H16.875", stroke: "current", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })] })));
};
exports.default = ArrowRightIcon;
